import { User, UserOrganization } from '../models/user.model';

/**
 * Static identity used for every request when the server runs with
 * AUTH_DISABLED=true (e2e tests). Mirrors an Auth0 `sub` claim.
 */
export const AUTH_DISABLED_USER_SUB = 'auth0|auth-disabled-test-user';

/** Organization the {@link AUTH_DISABLED_USER} belongs to. */
export const AUTH_DISABLED_ORGANIZATION: UserOrganization = Object.freeze({
  id: 'org_auth_disabled',
  name: 'e2e',
  display_name: 'E2E Test Organization',
});

/** User resolved by the server's users service when auth is disabled. */
export const AUTH_DISABLED_USER: User = Object.freeze({
  id: AUTH_DISABLED_USER_SUB,
  name: 'E2E Test User',
  nickname: 'e2e',
  picture: '',
  organizations: [AUTH_DISABLED_ORGANIZATION],
  readonly: false,
});
